// extracted by mini-css-extract-plugin
module.exports = {"icon":"m_br","font-size-small":"m_bs","fontSizeSmall":"m_bs","font-size-default":"m_bt","fontSizeDefault":"m_bt","font-size-large":"m_bv","fontSizeLarge":"m_bv"};